import { Fragment, useState, useEffect } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function UpdateSelectMenu({
  label,
  data,
  selectedData,
  setSelectedData,
  dotSelector,
}) {
  useEffect(() => {
    setSelectedData(selectedData);
  }, [selectedData]);

  return (
    <Listbox
      className={'w-full'}
      value={selectedData}
      onChange={setSelectedData}
    >
      {({ open }) => (
        <div>
          <Listbox.Label className='block text-sm font-medium text-brandText'>
            {label}
          </Listbox.Label>
          <div className='relative mt-1'>
            <Listbox.Button className='relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-brandPrimary focus:outline-none focus:ring-1 focus:ring-brandPrimary sm:text-sm'>
              <span className='block truncate text-brandText'>
                {selectedData ? selectedData[dotSelector] : 'Make a selection'}
              </span>
              <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2'>
                <SelectorIcon
                  className='h-5 w-5 text-gray-400'
                  aria-hidden='true'
                />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave='transition ease-in duration-100'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'
            >
              <Listbox.Options className='absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm'>
                {data.map((item) => (
                  <Listbox.Option
                    key={item.id}
                    className={({ active }) =>
                      classNames(
                        active
                          ? 'bg-brandPrimary text-white'
                          : 'text-brandText',
                        'relative cursor-default select-none py-2 pl-3 pr-9',
                      )
                    }
                    placeholder='Select a concern'
                    value={item}
                  >
                    {({ selectedData, active }) => (
                      <>
                        <span
                          className={classNames(
                            selectedData ? 'font-semibold' : 'font-normal',
                            'block truncate',
                          )}
                        >
                          {item[dotSelector]}
                        </span>

                        {selectedData ? (
                          <span
                            className={classNames(
                              active ? 'text-white' : 'text-brandText',
                              'absolute inset-y-0 right-0 flex items-center pr-4',
                            )}
                          >
                            <CheckIcon className='h-5 w-5' aria-hidden='true' />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </div>
      )}
    </Listbox>
  );
}
